export class PublicationModuleOptions {

    public static readonly DOCUMENTATION_ARTICLE = 'Publikationen-RES-HISinOne.xhtml';
    public static readonly DOCUMENTATION_TITLE= 'fs.res.documentation.publication';

    public static readonly RIGHT_CHANGE = [
        'RIGHT_FS_RES_PUBLICATION_CHANGE_PUBLICATION'
    ];
    public static readonly RIGHT_CREATE = [
        'RIGHT_FS_RES_PUBLICATION_CREATE_PUBLICATION',
        'RIGHT_FS_RES_CREATE_FOO_FROM_MENU'
    ];
    public static readonly RIGHT_DELETE = [
        'RIGHT_FS_RES_PUBLICATION_EDIT_PUBLICATION',
        'RIGHT_FS_RES_PUBLICATION_EDIT_PUBLICATION_OWN'
    ];
    public static readonly RIGHT_EDIT= [
        'RIGHT_FS_RES_PUBLICATION_EDIT_PUBLICATION',
        'RIGHT_FS_RES_PUBLICATION_EDIT_PUBLICATION_OWN'
    ];
    public static readonly RIGHT_IMPORT= [
        'RIGHT_FS_RES_PUBLICATION_IMPORT_PUBLICATION_EXPERIMENTAL',
        'RIGHT_FS_RES_PUBLICATION_IMPORT_PUBLICATION',
        'RIGHT_FS_RES_PUBLICATION_IMPORT_PUBLICATION_OWN'
    ];
    public static readonly RIGHT_VIEW = [
        'RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION',
        'RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION_OWN',
        'RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION_BY_TYPE',
        'RIGHT_FS_RES_PUBLICATION_VIEW_PUBLICATION_VISIBLE'
    ];

    public static readonly SEARCH_CONFIGURATION_FILENAME = 'fs/res/searchPublication.xml';
}
